import { I18nText } from '../api/dtos';

function firstNonNull<T>(...args: Array<T | null | undefined>): T | undefined {
    for (let arg of args) {
        if (arg !== null && arg !== undefined) {
            return arg;
        }
    }
    return undefined; // or some default value
}

export function withFallbackI18nFill(value: I18nText): I18nText {
    const firstFilledValue = firstNonNull(value.en, value.de, value.pl, value.da, value.nb);
    return {
        de: value.de || firstFilledValue,
        da: value.da || firstFilledValue,
        nb: value.nb || firstFilledValue,
        en: value.en || firstFilledValue,
        pl: value.pl || firstFilledValue
    };
}


// Type derived from I18nText keys to ensure they stay in sync
export type SupportedLanguage = keyof I18nText;
export type RequiredSupportedLanguage = keyof Required<I18nText>;

// Const object that acts like an enum, with keys derived from I18nText
export const SupportedLanguages = {
    EN: 'en' as const,
    DE: 'de' as const,
    PL: 'pl' as const,
    DA: 'da' as const,
    NB: 'nb' as const
} satisfies Record<string, RequiredSupportedLanguage>;

export function cleanUpUnsupportedLanguages(keys: SupportedLanguage[]): SupportedLanguage[] {
    return keys.filter((language) => Object.values(SupportedLanguages).includes(language));
}